/**
 * The estate's catalogue raisonné and the studio's own book.
 */
import type {
  EstateCatalogueResponse,
  RegisterStudioWorkRequest,
  RegisterStudioWorkResponse,
  SetStudioRecordRequest,
  StudioResponse,
} from "@ondo/shared";

import { request, requestWith } from "./request.ts";

/**
 * The estate's catalogue raisonné: header and rows in one response, because
 * the header's counts are computed over the rows it arrived with.
 */
export const fetchEstateCatalogue = () =>
  request<EstateCatalogueResponse>("/estate/catalogue");

/** One-way. The server refuses anyone but the identity holder at admin. */
export const declareCatalogueComplete = (artistId: string) =>
  request<void>(`/estate/catalogue/${artistId}/complete`, {});

/** The studio's book: owned works with the private production record. */
export const fetchStudioWorks = () =>
  request<StudioResponse>("/estate/studio").then((body) => body.works);

/**
 * A work registered as the studio's own — one call, one transaction. The
 * photographs follow separately through `uploadWorkImages`, because they need
 * the work's id and the work does not exist until this answers.
 */
export const registerStudioWork = (body: RegisterStudioWorkRequest) =>
  request<RegisterStudioWorkResponse>("/estate/studio", body satisfies RegisterStudioWorkRequest);

/** The whole record, replaced — PUT semantics, the form sends every field. */
export const setStudioRecord = (workId: string, body: SetStudioRecordRequest) =>
  requestWith<void>("PUT", `/estate/studio/${workId}`, body satisfies SetStudioRecordRequest);
